import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Tip.pcss';

export default class Tip extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        className: PropTypes.string,
        content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        onClick: PropTypes.func
    };

    static defaultProps = {
        position: 'top',
        onClick: () => {}
    };

    render() {
        const {children, className, position, content, onClick} = this.props;
        return (
            <div className={classNames(styles.tip, styles[position], className)} onClick={onClick}>
                {children}
                <i>{content}</i>
            </div>
        );
    }
}
